/* ============================================================
   SOCCER REVOLUTION — JavaScript v3.0
   Vanilla ES6+ | Sin dependencias | Nike × Supreme × Fútbol Emotion
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     UTILIDADES
     ---------------------------------------------------------- */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

  function debounce(fn, ms = 200) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  }

  function formatMoney(cents) {
    const n = (cents / 100).toFixed(2);
    return window.Shopify?.currency?.active
      ? `${window.Shopify.currency.active} ${n}`
      : `Q${n}`;
  }

  /* ----------------------------------------------------------
     1. PRELOADER — handled by inline script in theme.liquid.
     Call the shared hide function early if the page is already loaded.
     ---------------------------------------------------------- */
  if (window.__srHidePreloader) {
    if (document.readyState === 'complete') {
      setTimeout(window.__srHidePreloader, 600);
    }
  }

  /* ----------------------------------------------------------
     2. STICKY HEADER
     ---------------------------------------------------------- */
  function initStickyHeader() {
    const header = $('#sr-header');
    if (!header) return;
    const update = () => header.classList.toggle('scrolled', window.scrollY > 60);
    on(window, 'scroll', update, { passive: true });
    update();
  }

  /* ----------------------------------------------------------
     3. PROMO BAR
     ---------------------------------------------------------- */
  function initPromoBar() {
    const bar = $('.sr-promo-bar');
    const btn = $('.sr-promo-bar__close');
    if (!bar || !btn) return;
    if (sessionStorage.getItem('sr-promo-closed')) {
      bar.style.display = 'none';
      return;
    }
    on(btn, 'click', () => {
      bar.style.height = bar.offsetHeight + 'px';
      bar.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        bar.style.transition = 'height 0.3s ease, padding 0.3s ease';
        bar.style.height = '0';
        bar.style.paddingTop = '0';
        bar.style.paddingBottom = '0';
      });
      setTimeout(() => bar.remove(), 320);
      sessionStorage.setItem('sr-promo-closed', '1');
    });
  }

  /* ----------------------------------------------------------
     4. OVERLAY
     ---------------------------------------------------------- */
  const Overlay = {
    el: null,
    init() { this.el = $('#sr-overlay'); },
    show(zIndex = 100) {
      if (!this.el) return;
      if (zIndex) this.el.style.zIndex = zIndex;
      this.el.classList.add('open');
      document.body.style.overflow = 'hidden';
    },
    hide() {
      if (!this.el) return;
      this.el.classList.remove('open');
      document.body.style.overflow = '';
    }
  };

  /* ----------------------------------------------------------
     5. MOBILE MENU
     ---------------------------------------------------------- */
  function initMobileMenu() {
    const menu    = $('#sr-mobile-menu');
    const toggles = $$('[data-hamburger]');
    const close   = menu?.querySelector('.sr-mobile-menu__close');
    if (!menu) return;

    let lastFocused = null;

    function focusableEls() {
      return $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', menu)
        .filter(el => el.offsetParent !== null);
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      const items = focusableEls();
      if (!items.length) return;
      const first = items[0];
      const last  = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }

    const open  = (e) => {
      lastFocused = e && e.currentTarget ? e.currentTarget : document.activeElement;
      menu.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      toggles.forEach(t => t.setAttribute('aria-expanded', 'true'));
      Overlay.show(199);
      document.addEventListener('keydown', trapFocus);
      const firstLink = menu.querySelector('.sr-mobile-menu__close') || focusableEls()[0];
      if (firstLink) firstLink.focus();
    };
    const closeMenu = () => {
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      toggles.forEach(t => t.setAttribute('aria-expanded', 'false'));
      Overlay.hide();
      document.removeEventListener('keydown', trapFocus);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    toggles.forEach(t => on(t, 'click', open));
    if (close) on(close, 'click', closeMenu);
    on(Overlay.el, 'click', closeMenu);
    on(document, 'keydown', e => {
      if (e.key === 'Escape' && menu.classList.contains('open')) closeMenu();
    });

    // Submenus
    $$('.sr-mobile-menu__link[data-submenu]', menu).forEach(link => {
      on(link, 'click', e => {
        e.preventDefault();
        const id = link.dataset.submenu;
        const sub = $(`#${id}`);
        if (!sub) return;
        const isOpen = sub.classList.contains('open');
        $$('.sr-mobile-submenu.open', menu).forEach(s => s.classList.remove('open'));
        if (!isOpen) sub.classList.add('open');
        const chevron = link.querySelector('.chevron');
        if (chevron) chevron.style.transform = isOpen ? '' : 'rotate(180deg)';
      });
    });
  }

  /* ----------------------------------------------------------
     5b. MEGA MENU (teclado + click) — antes solo abría con :hover,
     inoperable por teclado pese a tener aria-haspopup/aria-expanded.
     El :hover del CSS queda como mejora progresiva para mouse.
     ---------------------------------------------------------- */
  function initMegaMenu() {
    const trigger = $('#sr-mega-menu-trigger');
    const item    = trigger?.closest('[data-mega-menu-item]');
    const menu    = item?.querySelector('.sr-mega-menu');
    if (!trigger || !item || !menu) return;

    function openMenu() {
      item.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function closeMenu() {
      item.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function isOpen() { return item.classList.contains('open'); }

    on(trigger, 'click', () => { isOpen() ? closeMenu() : openMenu(); });

    on(document, 'keydown', e => {
      if (e.key === 'Escape' && isOpen()) { closeMenu(); trigger.focus(); }
    });

    // Cerrar al hacer click afuera o al perder el foco fuera del menú
    on(document, 'click', e => {
      if (isOpen() && !item.contains(e.target)) closeMenu();
    });
    on(document, 'focusin', e => {
      if (isOpen() && !item.contains(e.target)) closeMenu();
    });
  }

  /* ----------------------------------------------------------
     6. SEARCH BAR TOGGLE
     ---------------------------------------------------------- */
  function initSearch() {
    const toggles = $$('[data-search-toggle]');
    const bar     = $('.sr-search-bar');
    const input   = $('#sr-search-input') || bar?.querySelector('input');
    const results = $('#sr-search-results');
    if (!toggles.length || !bar) return;

    function escapeHTML(str) {
      return String(str).replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
    }
    function hideResults() {
      if (!results) return;
      results.hidden = true;
      results.innerHTML = '';
    }

    toggles.forEach(toggle => {
      on(toggle, 'click', () => {
        const isOpen = bar.classList.toggle('open');
        if (isOpen && input) { input.focus(); } else { hideResults(); }
      });
    });
    on(document, 'keydown', e => {
      if (e.key === 'Escape') { bar.classList.remove('open'); hideResults(); }
    });

    /* Búsqueda predictiva: sugerencias mientras el cliente escribe,
       en vez de obligarlo a enviar el formulario para ver resultados. */
    if (input && results) {
      const runSearch = debounce(() => {
        const q = input.value.trim();
        if (q.length < 2) { hideResults(); return; }
        fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`)
          .then(r => r.json())
          .then(data => {
            const products = data?.resources?.results?.products || [];
            if (!products.length) {
              results.innerHTML = `<div class="sr-search-results__empty">Sin resultados para "${escapeHTML(q)}"</div>`;
              results.hidden = false;
              return;
            }
            results.innerHTML = products.map(p => {
              const img = p.featured_image?.url || p.image || '';
              // El endpoint devuelve el precio en quetzales sin formato (ej. "475.00");
              // se convierte con el mismo helper de moneda que usa el resto del sitio.
              let price = '';
              if (p.price) {
                price = window.srCurrency
                  ? window.srCurrency.fmt(parseFloat(p.price), window.srCurrency.current())
                  : `Q${p.price}`;
              }
              return `<a href="${p.url}" class="sr-search-results__item">
                ${img ? `<img src="${img}" alt="" loading="lazy">` : `<span class="sr-search-results__noimg">⚽</span>`}
                <span class="sr-search-results__info">
                  <span class="sr-search-results__title">${escapeHTML(p.title || '')}</span>
                  ${price ? `<span class="sr-search-results__price">${escapeHTML(price)}</span>` : ''}
                </span>
              </a>`;
            }).join('');
            results.hidden = false;
          })
          .catch(() => hideResults());
      }, 300);

      on(input, 'input', runSearch);
      on(input, 'focus', () => { if (input.value.trim().length >= 2) runSearch(); });
      on(document, 'click', e => {
        if (!bar.contains(e.target)) hideResults();
      });
    }
  }

  /* ----------------------------------------------------------
     7. CART DRAWER
     ---------------------------------------------------------- */
  const CartDrawer = {
    drawer: null,
    bodyEl: null,
    countEls: [],
    init() {
      this.drawer  = $('#sr-cart-drawer');
      this.bodyEl  = this.drawer?.querySelector('.sr-cart-drawer__body');
      this.countEls = $$('.sr-cart-count');
      // sr-cart-drawer.js (loaded after) handles all open/close/rendering.
      // Only sync count here to avoid double-binding [data-open-cart].
      this.updateCount();
    },
    open() {
      if (!this.drawer) return;
      this.refresh();
      this.drawer.classList.add('open');
      Overlay.show(199);
    },
    close() {
      if (!this.drawer) return;
      this.drawer.classList.remove('open');
      Overlay.hide();
    },
    async refresh() {
      try {
        const res  = await fetch('/cart.js');
        const cart = await res.json();
        this.render(cart);
        this.updateCount(cart.item_count);
      } catch (e) { console.error('Cart refresh failed', e); }
    },
    updateCount(n) {
      if (n === undefined) {
        fetch('/cart.js')
          .then(r => r.json())
          .then(c => this.updateCount(c.item_count));
        return;
      }
      this.countEls.forEach(el => {
        el.textContent = n;
        el.classList.toggle('visible', n > 0);
      });
    },
    render(cart) {
      if (!this.bodyEl) return;
      if (cart.item_count === 0) {
        this.bodyEl.innerHTML = `
          <div class="sr-cart-drawer__empty">
            <span class="sr-cart-drawer__empty-icon">🛒</span>
            <p style="font-weight:600;margin-bottom:.5rem">Tu carrito está vacío</p>
            <a href="/collections/all" class="sr-btn sr-btn--gold sr-btn--sm" style="margin-top:1rem" onclick="CartDrawer.close()">
              Ver camisolas ⚽
            </a>
          </div>`;
        const foot = this.drawer.querySelector('.sr-cart-drawer__foot');
        if (foot) foot.style.display = 'none';
        return;
      }

      const foot = this.drawer.querySelector('.sr-cart-drawer__foot');
      if (foot) foot.style.display = '';

      this.bodyEl.innerHTML = cart.items.map(item => `
        <div class="sr-cart-drawer__item" data-key="${item.key}">
          <a href="${item.url}">
            <img class="sr-cart-drawer__img" src="${item.featured_image?.url || ''}" alt="${item.product_title}" loading="lazy">
          </a>
          <div>
            <p class="sr-cart-drawer__name">${item.product_title}</p>
            <p class="sr-cart-drawer__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</p>
            <div class="sr-qty" data-key="${item.key}" style="margin-top:.5rem">
              <button class="sr-qty__btn" data-action="decrease">−</button>
              <input class="sr-qty__input" type="number" value="${item.quantity}" min="0" readonly>
              <button class="sr-qty__btn" data-action="increase">+</button>
            </div>
          </div>
          <div>
            <p class="sr-cart-drawer__price">${formatMoney(item.final_line_price)}</p>
            <button style="color:var(--danger);font-size:.75rem;margin-top:.5rem;opacity:.7"
              onclick="CartDrawer.removeItem('${item.key}')">× Eliminar</button>
          </div>
        </div>`).join('');

      const subtotalEl = this.drawer.querySelector('.sr-cart-drawer__subtotal-value');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      this.bindQty();
    },
    bindQty() {
      $$('.sr-qty', this.bodyEl).forEach(wrap => {
        const key  = wrap.dataset.key;
        const inp  = wrap.querySelector('.sr-qty__input');
        $$('.sr-qty__btn', wrap).forEach(btn => {
          on(btn, 'click', async () => {
            const delta  = btn.dataset.action === 'increase' ? 1 : -1;
            const newQty = Math.max(0, parseInt(inp.value) + delta);
            inp.value = newQty;
            await this.changeQty(key, newQty);
          });
        });
      });
    },
    async changeQty(key, qty) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        const cart = await res.json();
        this.render(cart);
        this.updateCount(cart.item_count);
      } catch (e) { Toast.show('Error al actualizar el carrito', 'error'); }
    },
    async removeItem(key) {
      await this.changeQty(key, 0);
    }
  };

  window.CartDrawer = CartDrawer;

  /* ----------------------------------------------------------
     8. UPDATE CART COUNT (global)
     ---------------------------------------------------------- */
  function updateCartCount() { CartDrawer.updateCount(); }
  window.updateCartCount = updateCartCount;

  /* ----------------------------------------------------------
     9. TOAST
     ---------------------------------------------------------- */
  const Toast = {
    container: null,
    init() {
      this.container = $('#sr-toast-container');
      if (!this.container) {
        this.container = document.createElement('div');
        this.container.id = 'sr-toast-container';
        document.body.appendChild(this.container);
      }
    },
    show(msg, type = 'default', duration = 3000) {
      if (!this.container) this.init();
      const icons = { success: '✓', error: '✕', warning: '⚠', default: '⚽' };
      const toast = document.createElement('div');
      toast.className = `sr-toast sr-toast--${type}`;
      toast.innerHTML = `<span>${icons[type] || icons.default}</span><span>${msg}</span>`;
      this.container.appendChild(toast);
      setTimeout(() => {
        toast.classList.add('leaving');
        setTimeout(() => toast.remove(), 350);
      }, duration);
    }
  };

  window.Toast = Toast;

  /* ----------------------------------------------------------
     10. WISHLIST (localStorage)
     ---------------------------------------------------------- */
  const Wishlist = {
    key: 'sr-wishlist',
    get() { try { return JSON.parse(localStorage.getItem(this.key) || '[]'); } catch { return []; } },
    save(list) { localStorage.setItem(this.key, JSON.stringify(list)); },
    toggle(id) {
      const list = this.get();
      const idx  = list.indexOf(String(id));
      if (idx > -1) { list.splice(idx, 1); Toast.show('Quitado de favoritos', 'default'); }
      else          { list.push(String(id)); Toast.show('Guardado en favoritos ❤️', 'success'); }
      this.save(list);
      return idx === -1;
    },
    has(id) { return this.get().includes(String(id)); },
    init() {
      $$('[data-wishlist-id]').forEach(btn => {
        const id = btn.dataset.wishlistId;
        if (this.has(id)) btn.classList.add('active');
        on(btn, 'click', e => {
          e.preventDefault();
          const isNow = this.toggle(id);
          btn.classList.toggle('active', isNow);
        });
      });
    }
  };

  window.Wishlist = Wishlist;

  /* ----------------------------------------------------------
     11. ADD TO CART — Quick Add
     ---------------------------------------------------------- */
  async function addToCart(variantId, qty = 1, properties = {}) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty, properties })
      });
      if (!res.ok) throw new Error('Add failed');
      await res.json();
      CartDrawer.refresh();
      CartDrawer.open();
      Toast.show('¡Agregado al carrito! 🛒', 'success');
      return true;
    } catch (e) {
      Toast.show('Error al agregar. Intenta de nuevo.', 'error');
      return false;
    }
  }

  window.addToCart = addToCart;

  /* ----------------------------------------------------------
     12. PRODUCT PAGE — SIZE SELECTOR
     ---------------------------------------------------------- */
  function initSizeSelector() {
    $$('.sr-size-btn').forEach(btn => {
      if (btn.classList.contains('sold-out')) return;
      on(btn, 'click', () => {
        const group = btn.closest('.sr-size-grid');
        $$('.sr-size-btn', group).forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        // Update hidden variant input
        const varId = btn.dataset.variantId;
        if (varId) {
          const inp = document.getElementById('sr-variant-id');
          if (inp) inp.value = varId;
        }
        // Update price if variant has different price
        const price = btn.dataset.price;
        if (price) updateProductPrice(parseInt(price));
      });
    });
  }

  function updateProductPrice(cents) {
    const el = $('.sr-product-price');
    if (el) el.textContent = formatMoney(cents);
  }

  /* ----------------------------------------------------------
     13. SLEEVE TOGGLE
     ---------------------------------------------------------- */
  function initSleeveToggle() {
    const btns = $$('.sr-sleeve-btn');
    if (!btns.length) return;
    btns.forEach(btn => {
      on(btn, 'click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const img = btn.dataset.image;
        if (img) {
          const mainImg = $('.sr-product-gallery__main-img');
          if (mainImg) {
            mainImg.style.opacity = '0';
            setTimeout(() => {
              mainImg.src = img;
              mainImg.style.opacity = '1';
            }, 200);
          }
        }
      });
    });
  }

  /* ----------------------------------------------------------
     14. VERSION SELECTOR (Réplica / Player Edition / Authentic)
     ---------------------------------------------------------- */
  function initVersionSelector() {
    const btns = $$('.sr-version-btn');
    if (!btns.length) return;
    btns.forEach(btn => {
      on(btn, 'click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const price = btn.dataset.price;
        if (price) updateProductPrice(parseInt(price));
        const varId = btn.dataset.variantId;
        if (varId) {
          const inp = document.getElementById('sr-variant-id');
          if (inp) inp.value = varId;
        }
      });
    });
  }

  /* ----------------------------------------------------------
     15. PATCH SELECTOR
     ---------------------------------------------------------- */
  function initPatchSelector() {
    const btns = $$('.sr-patch-btn');
    if (!btns.length) return;
    btns.forEach(btn => {
      on(btn, 'click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const price = parseInt(btn.dataset.extra || '0');
        // Add patch price to base price
        const basePrice = parseInt($('.sr-product-page')?.dataset.basePrice || '0');
        if (basePrice) updateProductPrice(basePrice + price);
      });
    });
  }

  /* ----------------------------------------------------------
     16. PRODUCT GALLERY (Main + Thumbs + Lightbox + Zoom)
     ---------------------------------------------------------- */
  function initProductGallery() {
    const mainImg   = $('.sr-product-gallery__main-img');
    const thumbs    = $$('.sr-product-gallery__thumb');
    const lightbox  = $('#sr-lightbox');
    const lbImg     = lightbox?.querySelector('.sr-product-gallery__main-img, .sr-lightbox__img');
    const zoomBtn   = $('[data-gallery-zoom]');
    const lbClose   = lightbox?.querySelector('.sr-lightbox__close');
    if (!mainImg) return;

    // Thumbnails
    thumbs.forEach((thumb, i) => {
      on(thumb, 'click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        const src = thumb.dataset.src || thumb.querySelector('img')?.src;
        if (src) {
          mainImg.style.transition = 'opacity 0.2s ease';
          mainImg.style.opacity = '0';
          setTimeout(() => {
            mainImg.src = src;
            mainImg.style.opacity = '1';
          }, 200);
        }
      });
    });

    // Zoom click
    on(mainImg, 'click', () => {
      if (mainImg.classList.contains('zoomed')) {
        mainImg.classList.remove('zoomed');
      } else {
        openLightbox(mainImg.src);
      }
    });

    // Zoom hover (desktop)
    on(mainImg, 'mousemove', e => {
      if (!mainImg.classList.contains('zoomed')) return;
      const rect = mainImg.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width * 100).toFixed(2);
      const y = ((e.clientY - rect.top) / rect.height * 100).toFixed(2);
      mainImg.style.setProperty('--mx', x + '%');
      mainImg.style.setProperty('--my', y + '%');
    });

    // Lightbox
    function openLightbox(src) {
      if (!lightbox) return;
      const img = lightbox.querySelector('.sr-lightbox__img');
      if (img) img.src = src;
      lightbox.classList.add('open');
      Overlay.show(299);
    }

    if (zoomBtn) on(zoomBtn, 'click', () => openLightbox(mainImg.src));
    if (lbClose) on(lbClose, 'click', () => { lightbox.classList.remove('open'); Overlay.hide(); });
    on(lightbox, 'click', e => {
      if (e.target === lightbox) { lightbox.classList.remove('open'); Overlay.hide(); }
    });

    // Swipe on mobile
    initSwipe($('.sr-product-gallery__main'), (dir) => {
      const current = thumbs.findIndex(t => t.classList.contains('active'));
      const next = dir === 'left'
        ? Math.min(current + 1, thumbs.length - 1)
        : Math.max(current - 1, 0);
      thumbs[next]?.click();
    });
  }

  /* ----------------------------------------------------------
     17. PERSONALIZATION (real-time preview)
     ---------------------------------------------------------- */
  function initPersonalization() {
    const toggle    = $('[data-personalization-toggle]');
    const body      = $('.sr-personalization__body');
    const nameInput = $('#sr-custom-name');
    const numInput  = $('#sr-custom-number');
    const previewName = $('#sr-preview-name');
    const previewNum  = $('#sr-preview-number');

    if (toggle && body) {
      on(toggle, 'click', () => body.classList.toggle('open'));
    }

    // Also watch the toggle checkbox
    const checkbox = $('[data-personalization-check]');
    if (checkbox) {
      on(checkbox, 'change', () => {
        if (body) body.classList.toggle('open', checkbox.checked);
      });
    }

    if (nameInput && previewName) {
      on(nameInput, 'input', () => {
        previewName.textContent = nameInput.value.toUpperCase() || 'TU NOMBRE';
      });
    }

    if (numInput && previewNum) {
      on(numInput, 'input', () => {
        previewNum.textContent = numInput.value || '10';
      });
    }

    // Font picker
    $$('.sr-font-btn').forEach(btn => {
      on(btn, 'click', () => {
        $$('.sr-font-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const font = btn.dataset.font;
        if (previewName) previewName.style.fontFamily = font || 'inherit';
      });
    });

    // Color picker
    $$('.sr-color-swatch').forEach(sw => {
      on(sw, 'click', () => {
        $$('.sr-color-swatch').forEach(s => s.classList.remove('active'));
        sw.classList.add('active');
        const color = sw.dataset.color;
        if (color) {
          if (previewName) previewName.style.color = color;
          if (previewNum)  previewNum.style.color  = color;
        }
      });
    });
  }

  /* ----------------------------------------------------------
     18. PERSONALIZATION CTA (homepage)
     ---------------------------------------------------------- */
  function initPersonalizationCTA() {
    const nameInput = $('#sr-cta-name');
    const numInput  = $('#sr-cta-number');
    const prevName  = $('#sr-cta-preview-name');
    const prevNum   = $('#sr-cta-preview-number');

    if (nameInput && prevName) {
      on(nameInput, 'input', () => {
        prevName.textContent = nameInput.value.toUpperCase() || 'TU NOMBRE';
      });
    }

    if (numInput && prevNum) {
      on(numInput, 'input', () => {
        prevNum.textContent = numInput.value || '10';
      });
    }
  }

  /* ----------------------------------------------------------
     19. SIZE GUIDE MODAL
     ---------------------------------------------------------- */
  function initSizeGuideModal() {
    const modal    = $('#sr-size-modal');
    const triggers = $$('[data-open-size-guide]');
    const close    = modal?.querySelector('.sr-modal__close');
    if (!modal) return;

    triggers.forEach(t => {
      on(t, 'click', e => {
        e.preventDefault();
        modal.classList.add('open');
        Overlay.show(299);
      });
    });

    if (close) on(close, 'click', () => { modal.classList.remove('open'); Overlay.hide(); });
    on(modal, 'click', e => {
      if (e.target === modal) { modal.classList.remove('open'); Overlay.hide(); }
    });
    on(document, 'keydown', e => {
      if (e.key === 'Escape') { modal.classList.remove('open'); Overlay.hide(); }
    });
  }

  /* ----------------------------------------------------------
     20. ADD TO CART FORM (product page)
     ---------------------------------------------------------- */
  function initProductForm() {
    const form = $('#sr-product-form');
    if (!form) return;
    // sr-product-main.liquid has its own inline submit handler when #sr-add-to-cart exists.
    if ($('#sr-add-to-cart')) return;

    on(form, 'submit', async e => {
      e.preventDefault();
      const btn    = form.querySelector('[type="submit"]');
      const varId  = form.querySelector('[name="id"]')?.value;
      if (!varId) { Toast.show('Por favor selecciona una talla', 'warning'); return; }

      const qty  = parseInt(form.querySelector('[name="quantity"]')?.value || '1');
      const props = {};

      form.querySelectorAll('[name^="properties["]').forEach(inp => {
        if (inp.value.trim()) {
          const key = inp.name.match(/\[(.+)\]/)?.[1];
          if (key) props[key] = inp.value.trim();
        }
      });

      if (btn) btn.classList.add('sr-btn--loading');
      await addToCart(varId, qty, props);
      if (btn) btn.classList.remove('sr-btn--loading');
    });

    // Buy Now
    const buyNow = $('[data-buy-now]');
    if (buyNow) {
      on(buyNow, 'click', async () => {
        const varId = form.querySelector('[name="id"]')?.value;
        if (!varId) { Toast.show('Por favor selecciona una talla', 'warning'); return; }
        buyNow.classList.add('sr-btn--loading');
        const ok = await addToCart(varId, 1);
        buyNow.classList.remove('sr-btn--loading');
        if (ok) window.location = '/checkout';
      });
    }
  }

  /* ----------------------------------------------------------
     21. QUANTITY CONTROLS (+/-)
     ---------------------------------------------------------- */
  function initQtyControls() {
    on(document, 'click', e => {
      const btn = e.target.closest('.sr-qty__btn');
      if (!btn) return;
      const wrap = btn.closest('.sr-qty');
      const inp  = wrap?.querySelector('.sr-qty__input');
      if (!inp) return;

      const current = parseInt(inp.value) || 1;
      const action  = btn.dataset.action;
      const min = parseInt(inp.min ?? '1');
      const max = parseInt(inp.max ?? '99');

      if (action === 'decrease') inp.value = Math.max(min, current - 1);
      if (action === 'increase') inp.value = Math.min(max, current + 1);

      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ----------------------------------------------------------
     22. ACCORDION
     ---------------------------------------------------------- */
  function initAccordion() {
    $$('.sr-accordion__trigger').forEach(trigger => {
      on(trigger, 'click', () => {
        const item   = trigger.closest('.sr-accordion__item');
        const isOpen = item.classList.contains('open');
        const parent = item.closest('.sr-accordion');
        if (parent) $$('.sr-accordion__item.open', parent).forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ----------------------------------------------------------
     23. TABS
     ---------------------------------------------------------- */
  function initTabs() {
    $$('.sr-tabs').forEach(tabs => {
      const btns    = $$('.sr-tab-btn', tabs);
      const panels  = $$('.sr-tab-panel', tabs);

      btns.forEach((btn, i) => {
        on(btn, 'click', () => {
          btns.forEach(b => b.classList.remove('active'));
          panels.forEach(p => p.classList.remove('active'));
          btn.classList.add('active');
          if (panels[i]) panels[i].classList.add('active');
        });
      });
    });
  }

  /* ----------------------------------------------------------
     24. HERO — TYPEWRITER EFFECT
     ---------------------------------------------------------- */
  function initTypewriter() {
    const el = $('.sr-typewriter[data-words]');
    if (!el) return;
    const words = el.dataset.words.split(',').map(w => w.trim());
    let wi = 0, ci = 0, deleting = false;
    const type = () => {
      const word = words[wi];
      if (!deleting) {
        el.textContent = word.slice(0, ++ci);
        if (ci === word.length) { deleting = true; setTimeout(type, 1800); return; }
      } else {
        el.textContent = word.slice(0, --ci);
        if (ci === 0) { deleting = false; wi = (wi + 1) % words.length; }
      }
      setTimeout(type, deleting ? 60 : 100);
    };
    setTimeout(type, 400);
  }

  /* ----------------------------------------------------------
     25. HERO — FLOATING PARTICLES
     ---------------------------------------------------------- */
  function initParticles() {
    const container = $('.sr-hero__particles');
    if (!container) return;
    const count = window.innerWidth > 768 ? 20 : 10;
    for (let i = 0; i < count; i++) {
      const p = document.createElement('div');
      p.className = 'sr-hero__particle';
      p.style.cssText = `
        left: ${Math.random() * 100}%;
        top: ${Math.random() * 100}%;
        --duration: ${4 + Math.random() * 6}s;
        --delay: ${Math.random() * 4}s;
        width: ${2 + Math.random() * 4}px;
        height: ${2 + Math.random() * 4}px;
        opacity: ${0.3 + Math.random() * 0.7};
      `;
      container.appendChild(p);
    }
  }

  /* ----------------------------------------------------------
     26. ANIMATED COUNTERS (IntersectionObserver)
     ---------------------------------------------------------- */
  function initCounters() {
    const els = $$('[data-count-to]');
    if (!els.length) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el      = entry.target;
        const target  = parseFloat(el.dataset.countTo);
        const suffix  = el.dataset.suffix || '';
        const prefix  = el.dataset.prefix || '';
        const dur     = parseInt(el.dataset.duration || '2000');
        const dec     = parseInt(el.dataset.decimals || '0');
        const start   = performance.now();

        observer.unobserve(el);

        const animate = (now) => {
          const progress = Math.min((now - start) / dur, 1);
          const ease     = 1 - Math.pow(1 - progress, 3);
          const value    = (target * ease).toFixed(dec);
          el.textContent = prefix + value + suffix;
          if (progress < 1) requestAnimationFrame(animate);
        };
        requestAnimationFrame(animate);
      });
    }, { threshold: 0.3 });

    els.forEach(el => observer.observe(el));
  }

  /* ----------------------------------------------------------
     27. SCROLL REVEAL (IntersectionObserver)
     ---------------------------------------------------------- */
  function initReveal() {
    const els = $$('.sr-reveal, .sr-reveal-left, .sr-reveal-scale');
    if (!els.length) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(el => observer.observe(el));
  }

  /* ----------------------------------------------------------
     28. HERO SLIDER (sr-hero-banner)
     ---------------------------------------------------------- */
  function initHeroSlider() {
    const slider = $('.sr-hero-slider');
    if (!slider) return;
    const slides  = $$('.sr-hero-slide', slider);
    const dots    = $$('.sr-hero-dot', slider);
    const prevBtn = $('[data-hero-prev]', slider);
    const nextBtn = $('[data-hero-next]', slider);
    if (!slides.length) return;

    let current = 0;
    let autoplay;

    const goTo = (n) => {
      slides[current].classList.remove('active');
      dots[current]?.classList.remove('active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current]?.classList.add('active');
    };

    const startAuto = () => {
      autoplay = setInterval(() => goTo(current + 1), 5000);
    };

    slides[0]?.classList.add('active');
    dots[0]?.classList.add('active');
    startAuto();

    if (prevBtn) on(prevBtn, 'click', () => { goTo(current - 1); clearInterval(autoplay); startAuto(); });
    if (nextBtn) on(nextBtn, 'click', () => { goTo(current + 1); clearInterval(autoplay); startAuto(); });
    dots.forEach((dot, i) => on(dot, 'click', () => { goTo(i); clearInterval(autoplay); startAuto(); }));

    initSwipe(slider, dir => {
      goTo(dir === 'left' ? current + 1 : current - 1);
      clearInterval(autoplay); startAuto();
    });
  }

  /* ----------------------------------------------------------
     29. TEAMS SHOWCASE CAROUSEL
     ---------------------------------------------------------- */
  function initTeamsShowcase() {
    const wrap    = $('.sr-showcase-wrap');
    const track   = $('.sr-showcase-track');
    const slides  = $$('.sr-showcase-slide');
    const prevBtn = $('.sr-showcase-nav--prev');
    const nextBtn = $('.sr-showcase-nav--next');
    const dots    = $$('.sr-showcase-dot');
    if (!track || !slides.length) return;

    const perView = () => window.innerWidth >= 768 ? 3 : 1;
    let current  = 0;
    let autoplay;

    const clamp = (n) => Math.max(0, Math.min(n, slides.length - perView()));

    const goTo = (n) => {
      current = clamp(n);
      track.style.transform = `translateX(-${current * (100 / perView())}%)`;
      dots.forEach((d, i) => d.classList.toggle('active', i === current));
    };

    const startAuto = () => {
      autoplay = setInterval(() => {
        goTo(current + 1 > slides.length - perView() ? 0 : current + 1);
      }, 4000);
    };

    goTo(0);
    startAuto();

    if (prevBtn) on(prevBtn, 'click', () => { goTo(current - 1); clearInterval(autoplay); startAuto(); });
    if (nextBtn) on(nextBtn, 'click', () => { goTo(current + 1); clearInterval(autoplay); startAuto(); });
    dots.forEach((d, i) => on(d, 'click', () => { goTo(i); clearInterval(autoplay); startAuto(); }));
    on(window, 'resize', debounce(() => goTo(current)));
  }

  /* ----------------------------------------------------------
     30. POPULAR TEAMS — Drag-to-scroll
     ---------------------------------------------------------- */
  function initTeamPills() {
    const track = $('.sr-teams-track');
    if (!track) return;
    let isDown = false, startX, scrollL;
    on(track, 'mousedown',  e => { isDown = true; startX = e.pageX - track.offsetLeft; scrollL = track.scrollLeft; track.style.cursor = 'grabbing'; });
    on(track, 'mouseleave', () => { isDown = false; track.style.cursor = ''; });
    on(track, 'mouseup',    () => { isDown = false; track.style.cursor = ''; });
    on(track, 'mousemove',  e => { if (!isDown) return; e.preventDefault(); track.scrollLeft = scrollL - (e.pageX - track.offsetLeft - startX); });
  }

  /* ----------------------------------------------------------
     31. COLLECTION — Sort + Filter
     ---------------------------------------------------------- */
  function initCollectionFilters() {
    const sortEl = $('#sr-sort-by');
    if (sortEl) {
      on(sortEl, 'change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortEl.value);
        window.location = url.toString();
      });
    }

    const filterToggle = $('#sr-filter-toggle');
    const filterPanel  = $('#sr-filters-mobile');
    if (filterToggle && filterPanel) {
      on(filterToggle, 'click', () => {
        const isOpen = filterPanel.classList.toggle('open');
        filterToggle.setAttribute('aria-expanded', isOpen);
      });
    }
  }

  /* ----------------------------------------------------------
     32. CART PAGE — Qty update
     ---------------------------------------------------------- */
  function initCartPageQty() {
    on(document, 'change', async e => {
      const inp = e.target.closest('.sr-qty__input');
      if (!inp) return;
      const key = inp.dataset.key || inp.closest('[data-key]')?.dataset.key;
      if (!key) return;
      const qty = parseInt(inp.value);
      if (isNaN(qty)) return;
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        await res.json();
        window.location.reload();
      } catch { Toast.show('Error al actualizar carrito', 'error'); }
    });
  }

  /* ----------------------------------------------------------
     33. 3D CARD TILT
     ---------------------------------------------------------- */
  function initCardTilt() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.innerWidth < 768) return;

    $$('.sr-product-card__3d-tilt').forEach(card => {
      on(card, 'mousemove', e => {
        const rect = card.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top)  / rect.height - 0.5;
        card.style.transform = `perspective(800px) rotateY(${x * 10}deg) rotateX(${-y * 10}deg) translateY(-4px)`;
      });
      on(card, 'mouseleave', () => {
        card.style.transform = '';
      });
    });
  }

  /* ----------------------------------------------------------
     34. LAZY LOAD IMAGES
     ---------------------------------------------------------- */
  function initLazyLoad() {
    if ('loading' in HTMLImageElement.prototype) return;
    const imgs = $$('img[loading="lazy"]');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const img = e.target;
          if (img.dataset.src) img.src = img.dataset.src;
          observer.unobserve(img);
        }
      });
    });
    imgs.forEach(img => observer.observe(img));
  }

  /* ----------------------------------------------------------
     35. SWIPE HELPER (touch)
     ---------------------------------------------------------- */
  function initSwipe(el, callback) {
    if (!el) return;
    let startX = 0;
    on(el, 'touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    on(el, 'touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) callback(diff > 0 ? 'left' : 'right');
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     36. SMOOTH SCROLL
     ---------------------------------------------------------- */
  function initSmoothScroll() {
    on(document, 'click', e => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ----------------------------------------------------------
     37. SCROLL TO TOP
     ---------------------------------------------------------- */
  function initScrollToTop() {
    const btn = $('#sr-scroll-top');
    if (!btn) return;
    on(window, 'scroll', debounce(() => {
      btn.classList.toggle('visible', window.scrollY > 500);
    }, 100), { passive: true });
    on(btn, 'click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* ----------------------------------------------------------
     38. HERO PARALLAX
     ---------------------------------------------------------- */
  function initHeroParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const hero = $('.sr-hero');
    if (!hero) return;
    const bg = hero.querySelector('.sr-hero__bg');
    if (!bg) return;
    on(window, 'scroll', () => {
      if (window.scrollY > window.innerHeight) return;
      bg.style.transform = `translateY(${window.scrollY * 0.3}px)`;
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     39. CONTACT FORM VALIDATION
     ---------------------------------------------------------- */
  function initContactForm() {
    const form = $('#sr-contact-form');
    if (!form) return;
    on(form, 'submit', e => {
      const required = $$('[required]', form);
      let valid = true;
      required.forEach(inp => {
        if (!inp.value.trim()) {
          valid = false;
          inp.style.borderColor = 'var(--danger)';
          inp.addEventListener('input', () => { inp.style.borderColor = ''; }, { once: true });
        }
      });
      if (!valid) {
        e.preventDefault();
        Toast.show('Por favor completa todos los campos requeridos', 'warning');
      }
    });
  }

  /* ----------------------------------------------------------
     40. INJECT CART DRAWER HTML
     ---------------------------------------------------------- */
  function injectCartDrawer() {
    if ($('#sr-cart-drawer')) return;
    const html = `
    <div id="sr-cart-drawer" class="sr-cart-drawer" aria-label="Carrito" role="dialog" aria-modal="true">
      <div class="sr-cart-drawer__head">
        <p class="sr-cart-drawer__title">MI CARRITO</p>
        <button class="sr-cart-drawer__close" aria-label="Cerrar carrito">×</button>
      </div>
      <div class="sr-cart-drawer__body">
        <div class="sr-cart-drawer__empty">
          <span class="sr-cart-drawer__empty-icon">🛒</span>
          <p style="font-weight:600">Tu carrito está vacío</p>
          <a href="/collections/all" class="sr-btn sr-btn--gold sr-btn--sm" style="margin-top:1rem">Ver camisolas ⚽</a>
        </div>
      </div>
      <div class="sr-cart-drawer__foot" style="display:none">
        <div class="sr-cart-drawer__subtotal">
          <span class="sr-cart-drawer__subtotal-label">Total estimado</span>
          <span class="sr-cart-drawer__subtotal-value">Q0.00</span>
        </div>
        <p style="font-size:.75rem;color:var(--gray-400);margin-bottom:1rem;text-align:center">
          Impuestos e IVA incluidos. Envío calculado al pagar.
        </p>
        <a href="/checkout" data-checkout class="sr-btn sr-btn--gold sr-btn--full sr-btn--xl" style="margin-bottom:.75rem">
          🔒 FINALIZAR COMPRA
        </a>
        <a href="/cart" class="sr-btn sr-btn--outline-dark sr-btn--full sr-btn--sm">Ver carrito completo</a>
      </div>
    </div>`;
    document.body.insertAdjacentHTML('beforeend', html);
  }

  /* ----------------------------------------------------------
     41. INSTAGRAM GRID — HOVER STATS
     ---------------------------------------------------------- */
  function initInstagram() {
    $$('.sr-instagram__item').forEach(item => {
      const overlay = item.querySelector('.sr-instagram__item-overlay');
      if (!overlay) return;
      on(item, 'mouseenter', () => overlay.style.opacity = '1');
      on(item, 'mouseleave', () => overlay.style.opacity = '0');
    });
  }

  /* ----------------------------------------------------------
     42. COPY SHARE LINK
     ---------------------------------------------------------- */
  function initShareButton() {
    const btn = $('[data-share]');
    if (!btn) return;
    on(btn, 'click', async () => {
      try {
        if (navigator.share) {
          await navigator.share({ url: window.location.href, title: document.title });
        } else {
          await navigator.clipboard.writeText(window.location.href);
          Toast.show('¡Enlace copiado!', 'success');
        }
      } catch {}
    });
  }

  /* ----------------------------------------------------------
     INIT — DOMContentLoaded
     ---------------------------------------------------------- */
  function init() {
    injectCartDrawer();
    Overlay.init();

    initStickyHeader();
    initPromoBar();
    initMobileMenu();
    initMegaMenu();
    initSearch();

    CartDrawer.init();
    Toast.init();
    Wishlist.init();

    initQtyControls();
    initAccordion();
    initTabs();
    initSizeSelector();
    initSleeveToggle();
    initVersionSelector();
    initPatchSelector();
    initProductGallery();
    initPersonalization();
    initPersonalizationCTA();
    initSizeGuideModal();
    initProductForm();

    initHeroSlider();
    initTypewriter();
    initParticles();
    initTeamPills();
    initTeamsShowcase();
    initCollectionFilters();
    initCartPageQty();
    initCardTilt();
    initLazyLoad();
    initSmoothScroll();
    initScrollToTop();
    initHeroParallax();
    initContactForm();
    initInstagram();
    initShareButton();

    initReveal();
    initCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Expose public API */
  window.SoccerRevolution = {
    cart: CartDrawer,
    toast: Toast,
    wishlist: Wishlist,
    addToCart,
    updateCartCount
  };

})();
